export default class BaseRepository {
  static prepareParams = (param) => {
    let query = "";
    for (const [key, value] of Object.entries(param)) {
      query += `${key}= ${value}&`;
    }

    return query;
  };

  static serialize = (input) => {
    if (input instanceof FormData) return input;
    if (input instanceof HTMLFormElement) return new FormData(input);

    const fData = new FormData();

    if (typeof input?.length === "number" && input[0]?.form instanceof HTMLFormElement) {
      return new FormData(input[0].form);
    }

    if (input && typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value !== undefined && value !== null) fData.append(key, value);
      }
    }

    return fData;
  };

  //Handles GET requests, bearer token is optional, depends on the requirement of the api endpoint
  static get = async (url, token = "", params = {}) => {
    // let body = prepareBody(data);
    let query = this.prepareParams(params);

    const response = await fetch(`${url}${query}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return await response.json();
  };

  //Handles all post requests including file uploads, Bearer token is compulsory,
  //only authenticated users can post data to api
  static post = async (url, form, token = "", processed = false) => {
    let formData = processed ? form : this.serialize(form);

    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: formData,
    });

    return await response.json();
  };
}
